import type { HubCapsule } from '@aws-amplify/core';

/**
 * Amplify Hub auth listener that triggers session setup/teardown and reports
 * sanitized token-refresh outcomes to analytics.
 */
export const AuthListener = async (
  data: HubCapsule,
  setupSession: (isRefresh?: boolean) => Promise<void>,
  takedownSession: () => Promise<void>,
  setLoading: (loading: boolean) => void,
  captureAuthEvent: (event: 'tokenRefresh' | 'tokenRefresh_failure') => void
): Promise<void> => {
  const event = data.payload.event;

  if (event !== 'tokenRefresh') {
    setLoading(true);
  }

  switch (event) {
    case 'signIn':
      await setupSession();
      break;
    case 'signOut':
      await takedownSession();
      break;
    case 'tokenRefresh':
      captureAuthEvent('tokenRefresh');
      await setupSession();
      break;
    case 'tokenRefresh_failure':
      captureAuthEvent('tokenRefresh_failure');
      await takedownSession();
      break;
    default:
      break;
  }

  if (event !== 'tokenRefresh') {
    setLoading(false);
  }
};
